<app-mediaviewer class="image" [MediaId]="MediaId" [Width]="ThumbnailWidth" [Height]="ThumbnailHeight" [Thumbnail]="true" (click)="Clicked()"></app-mediaviewer>
@if (ShowDelete) {
  <div class="delete" style="margin-left:-20px; z-index: 1;" (click)="Delete()"><i class="icon fa fa-delete"></i></div>
}